import Subfolders from "components/app/project/subfolders";
import { useQuery } from "hooks/query";
import moment from "moment";
import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";

function Treeview() {
    const params: any = useParams();
    const query = useQuery();
    const history = useHistory();
    const streams = query
        .get("streams")!
        .split(",")
        .map((x) => parseInt(x));
    const projectId = params.projectId;
    const [dateFrom, setDateFrom] = useState(moment(query.get("datefrom")));
    const [dateTo, setDateTo] = useState(moment(query.get("dateto")).hour(23).minute(59).second(59));

    const setSubfolder = (subfolder: number) => {
        query.set("datefrom", dateFrom.format("YYYY-MM-DD"));
        query.set("dateto", dateTo.format("YYYY-MM-DD"));
        query.set("streams", streams.join(","));
        history.replace({
            search: `?${query.toString()}`,
        });
        window.location.href = window.location.href.replace(projectId + "/treeview", subfolder + "");
    };

    return (
        <div>
            <Subfolders projectId={projectId} dateFrom={dateFrom} dateTo={dateTo} setSubfolder={setSubfolder} streamIds={[7, 8, 9, 10, 11]} />
        </div>
    );
}

export default Treeview;
